import { HttpRequestMethod, send } from "./utils/send";
import { getUseDelete } from "./utils/useCrud/getUseDelete";

export const sendDeleteMatch = async (id: number): Promise<boolean> =>
  send<boolean>(`/matches/${id}`, HttpRequestMethod.DELETE);

export const useDeleteMatch = getUseDelete(["matches"], sendDeleteMatch);
